import React, { useEffect, useState } from "react";
import L from "leaflet"; // Импорт библиотеки Leaflet
import "leaflet-draw/dist/leaflet.draw.css";
import "leaflet/dist/leaflet.css";
import { MapContainer, Marker, Popup, TileLayer, GeoJSON } from "react-leaflet";
import { getCookie } from "typescript-cookie";
import KyLokal from "../../changeLang/drawLocalesKy";
import RuLokal from "../../changeLang/drawLocalesRu";
import styles from "./styles_map.module.css";

interface IContentPart {
  latitude: number;
  longitude: number;
}

const markers = [
  {
    latitude: 40.25989896756961, 

    longitude: 72.07408447154855,
    tooltip: `
      <div>
         <h3 style="margin-top: 0; margin-bottom: 8px; font-size: 16px; color: #333;">ФПФ «Эркин 95»</h3>
      <p style="margin: 4px 0;">
        <strong>Район:</strong> Кадамжайский<br />
        <strong>Вид животных:</strong> Овцы<br />
        <strong>Порода:</strong> Гиссар<br />
        <strong>Адрес и ФИО:</strong> Уч-Коргонский а/о, 0555662230, Сулайманов Ысмаил <br />
      </p>
      </div>
    `,
  },

  {
    latitude: 40.25596890234563, 

    longitude: 72.04112548841549 ,
    tooltip: `
      <div>
         <h3 style="margin-top: 0; margin-bottom: 8px; font-size: 16px; color: #333;">ФПФ «Умид»</h3>
      <p style="margin: 4px 0;">
        <strong>Район:</strong> Кадамжайский<br />
        <strong>Вид животных:</strong> Овцы<br />
        <strong>Порода:</strong> Гиссар<br />
        <strong>Адрес и ФИО:</strong> Уч-Коргонский а/о,
0777532135,
Нуманов Олимжон <br />
      </p>
      </div>
    `,
  },

  {
    latitude: 40.21268644695544, 

    longitude: 71.02774785874938,
    tooltip: `
      <div>
         <h3 style="margin-top: 0; margin-bottom: 8px; font-size: 16px; color: #333;">ФПФ «Мин-Чынар»</h3>
      <p style="margin: 4px 0;">
        <strong>Район:</strong> Кадамжайский<br />
        <strong>Вид животных:</strong> ИИМ<br />
        <strong>Порода:</strong> Алатауская<br />
        <strong>Адрес и ФИО:</strong> Ак-турпак а/о ,0222 270 037 ,Имаров Акжол <br />
      </p>
      </div>
    `,
  },

  {
    latitude: 40.283212658977156, 

    longitude: 72.06962127591598 ,
    tooltip: `
      <div>
         <h3 style="margin-top: 0; margin-bottom: 8px; font-size: 16px; color: #333;">ФПФ «Сохиб-Уч-Коргон»</h3>
      <p style="margin: 4px 0;">
        <strong>Район:</strong> Кадамжайский<br />
        <strong>Вид животных:</strong> Овцы<br />
        <strong>Порода:</strong> Жайдар<br />
        <strong>Адрес и ФИО:</strong> Уч-Коргонский а/о, 0777569686 ,Сулайманов Солижон <br />
      </p>
      </div>
    `,
  },

  {
    latitude: 40.20630946848016, 

    longitude: 71.0330054953089  ,
    tooltip: `
      <div>
         <h3 style="margin-top: 0; margin-bottom: 8px; font-size: 16px; color: #333;">ФПФ «Ыхтыяр»</h3>
      <p style="margin: 4px 0;">
        <strong>Район:</strong> Кадамжайский<br />
        <strong>Вид животных:</strong> КРС<br />
        <strong>Порода:</strong>Алатауская<br />
        <strong>Адрес и ФИО:</strong> а/о Ак-Турпак ,0772 656 895 ,Надиров Ыхтыяр <br />
      </p>
      </div>
    `,
  },

  {
    latitude: 39.943269434239994, 

    longitude: 71.25956349403097  ,
    tooltip: `
      <div>
         <h3 style="margin-top: 0; margin-bottom: 8px; font-size: 16px; color: #333;">ФПФ «Эрлан»</h3>
      <p style="margin: 4px 0;">
        <strong>Район:</strong> Кадамжайский<br />
        <strong>Вид животных:</strong> КРС<br />
        <strong>Порода:</strong> Алатауская<br />
        <strong>Адрес и ФИО:</strong> а/о Бирлик,
0776 615 565 ,Базарбаев Зиядилла <br />
      </p>
      </div>
    `,
  },

  
  {
    latitude: 39.827177403540915, 

    longitude: 69.51963793946578   ,
    tooltip: `
      <div>
         <h3 style="margin-top: 0; margin-bottom: 8px; font-size: 16px; color: #333;">ФПФ «Бекбол-Б»</h3>
      <p style="margin: 4px 0;">
        <strong>Район:</strong> Лейлекский<br />
        <strong>Вид животных:</strong> Овцы<br />
        <strong>Порода:</strong> Гиссар<br />
        <strong>Адрес и ФИО:</strong> Казыев С.,
0773133181,
Город Исфана <br />
      </p>
      </div>
    `,
  },

  {
    latitude: 39.82941851896259, 

    longitude: 69.55242526122836   ,
    tooltip: `
      <div>
         <h3 style="margin-top: 0; margin-bottom: 8px; font-size: 16px; color: #333;">ФПФ «ГАЗБЕК АЖЫ»</h3>
      <p style="margin: 4px 0;">
        <strong>Район:</strong> Лейлекский<br />
        <strong>Вид животных:</strong> Овцы<br />
        <strong>Порода:</strong> РГиссар<br />
        <strong>Адрес и ФИО:</strong> ш.Исфана, 
тел.0770 708003 ,Абдиманапов Абдыганы <br />
      </p>
      </div>
    `,
  },

  {
    latitude: 41.098366975356825, 

    longitude: 73.24007113496381  ,
    tooltip: `
      <div>
         <h3 style="margin-top: 0; margin-bottom: 8px; font-size: 16px; color: #333;">ФПФ «Назарбек»</h3>
      <p style="margin: 4px 0;">
        <strong>Район:</strong> Аксыйский<br />
        <strong>Вид животных:</strong> Лошади<br />
        <strong>Порода:</strong> Новокиргизская<br />
        <strong>Адрес и ФИО:</strong> Жерге-Тал а/о <br />
      </p>
      </div>
    `,
  },

  {
    latitude: 41.485078095846745,  

    longitude: 72.16712821218154 ,
    tooltip: `
      <div>
         <h3 style="margin-top: 0; margin-bottom: 8px; font-size: 16px; color: #333;">ФПФ «Назар-Ата»</h3>
      <p style="margin: 4px 0;">
        <strong>Район:</strong> Аксыйский<br />
        <strong>Вид животных:</strong> Овцы<br />
        <strong>Порода:</strong> Гиссар<br />
        <strong>Адрес и ФИО:</strong> Кош-Дөбө а/о ,0773 617666,
Романкулов Эдилбек <br />
      </p>
      </div>
    `,
  },

  {
    latitude: 41.52215431595109, 

    longitude: 71.74311958713007 ,
    tooltip: `
      <div>
         <h3 style="margin-top: 0; margin-bottom: 8px; font-size: 16px; color: #333;">ФПФ «Чолпон К»</h3>
      <p style="margin: 4px 0;">
        <strong>Район:</strong> Аксыйский<br />
        <strong>Вид животных:</strong> Овцы<br />
        <strong>Порода:</strong> Гиссар<br />
        <strong>Адрес и ФИО:</strong> Ак-Добенский а/о, 0777 020 659 ,Мамытов Чолпонкул <br />
      </p>
      </div>
    `,
  },

  {
    latitude: 42.61639166478374, 

    longitude: 71.19050391583846 ,
    tooltip: `
      <div>
         <h3 style="margin-top: 0; margin-bottom: 8px; font-size: 16px; color: #333;">ФПЗ «Орозбек»</h3>
      <p style="margin: 4px 0;">
        <strong>Район:</strong> Кара-Бууринский<br />
        <strong>Вид животных:</strong> Лошади<br />
        <strong>Порода:</strong> Чистокровно верховая<br />
        <strong>Адрес и ФИО:</strong> Аманбаев а/о <br />
      </p>
      </div>
    `,
  },

  {
    latitude: 41.62094611853302, 

    longitude: 71.92984627050278 ,
    tooltip: `
      <div>
         <h3 style="margin-top: 0; margin-bottom: 8px; font-size: 16px; color: #333;">ФПФ «Коргон»</h3>
      <p style="margin: 4px 0;">
        <strong>Район:</strong> Аксыйский<br />
        <strong>Вид животных:</strong> Овцы<br />
        <strong>Порода:</strong> Гиссар<br />
        <strong>Адрес и ФИО:</strong> Авлетимский а/о ,
0777 521319 ,Дыйканбаев Абдырасул <br />
      </p>
      </div>
    `,
  },

  {
    latitude: 40.99353419091747, 

    longitude: 72.53872664605873 ,
    tooltip: `
      <div>
         <h3 style="margin-top: 0; margin-bottom: 8px; font-size: 16px; color: #333;">ФПФ «Чолпон-Ата»</h3>
      <p style="margin: 4px 0;">
        <strong>Район:</strong> Ноокенский<br />
        <strong>Вид животных:</strong> Овцы<br />
        <strong>Порода:</strong> Гиссар<br />
        <strong>Адрес и ФИО:</strong> Сакалдинский, а/о 0778125289, Мамашов Зокиржон <br />
      </p>
      </div>
    `,
  },

  {
    latitude:40.88971579275333, 

    longitude: 73.00112015556059  ,
    tooltip: `
      <div>
         <h3 style="margin-top: 0; margin-bottom: 8px; font-size: 16px; color: #333;">ФПФ «Тагай-Тилек»</h3>
      <p style="margin: 4px 0;">
        <strong>Район:</strong> Сузакский<br />
        <strong>Вид животных:</strong> Овцы<br />
        <strong>Порода:</strong> Гиссар<br />
        <strong>Адрес и ФИО:</strong> Барпы а/о ,
0557000854 Тагаев Осор <br />
      </p>
      </div>
    `,
  },

  {
    latitude:41.00448929790251, 

    longitude: 73.07805944089625  ,
    tooltip: `
      <div>
         <h3 style="margin-top: 0; margin-bottom: 8px; font-size: 16px; color: #333;">ФПФ «Бекзат-А»</h3>
      <p style="margin: 4px 0;">
        <strong>Район:</strong> Сузакский<br />
        <strong>Вид животных:</strong> КРС<br />
        <strong>Порода:</strong> Абердин-ангус<br />
        <strong>Адрес и ФИО:</strong> а/о Багыш 0772155007,
0558717379,
Саражиев Алмамат <br />
      </p>
      </div>
    `,
  },
  
  {
    latitude:40.90439763590202, 

    longitude: 72.89215808832161  ,
    tooltip: `
      <div>
         <h3 style="margin-top: 0; margin-bottom: 8px; font-size: 16px; color: #333;">ФПФ «Бек-Иса»</h3>
      <p style="margin: 4px 0;">
        <strong>Район:</strong> Сузакский<br />
        <strong>Вид животных:</strong> Овцы<br />
        <strong>Порода:</strong> Гиссар<br />
        <strong>Адрес и ФИО:</strong> Улгу а/о ,
0701 626700 ,
Балтабаев Курсантбек <br />
      </p>
      </div>
    `,
  },
  {
    latitude:41.67222868321303, 
    longitude: 70.85482233144737 ,
    tooltip: `
      <div>
         <h3 style="margin-top: 0; margin-bottom: 8px; font-size: 16px; color: #333;">ФПФ «Болот-Ата»</h3>
      <p style="margin: 4px 0;">
        <strong>Район:</strong> Чаткалский<br />
        <strong>Вид животных:</strong>Овцы<br />
        <strong>Порода:</strong> Гиссар<br />
        <strong>Адрес и ФИО:</strong> Жаны-Базарский а/о ,тел.0772300001, Карабаев Кудайберди <br />
      </p>
      </div>
    `,
  },
  {
    latitude:40.53681061918334, 

    longitude: 72.95119257167255 ,
    tooltip: `
      <div>
         <h3 style="margin-top: 0; margin-bottom: 8px; font-size: 16px; color: #333;">ФПФ «Бекбоо»</h3>
      <p style="margin: 4px 0;">
        <strong>Район:</strong> Кара-Суйский<br />
        <strong>Вид животных:</strong> КРС<br />
        <strong>Порода:</strong> Алатауская<br />
        <strong>Адрес и ФИО:</strong> а/о Мады ,тел.0555 311 085, Мадазимов Бекболот <br />
      </p>
      </div>
    `,
  },

  {
    latitude:40.536419235999716, 

    longitude: 72.93685884723708  ,
    tooltip: `
      <div>
         <h3 style="margin-top: 0; margin-bottom: 8px; font-size: 16px; color: #333;">ФПФ «Чолпонай»</h3>
      <p style="margin: 4px 0;">
        <strong>Район:</strong> Кара- Суйский<br />
        <strong>Вид животных:</strong> КРС<br />
        <strong>Порода:</strong> Абердин-ангус<br />
        <strong>Адрес и ФИО:</strong> а/о Мады ,тел.0552 703 203 ,Токуров Маматжалил <br />
      </p>
      </div>
    `,
  },

  {
    latitude:40.30604732976796, 

    longitude: 73.23362915571632  ,
    tooltip: `
      <div>
         <h3 style="margin-top: 0; margin-bottom: 8px; font-size: 16px; color: #333;">ФПФ «Агро-Элита-КЖ»</h3>
      <p style="margin: 4px 0;">
        <strong>Район:</strong> Кара- Суйский<br />
        <strong>Вид животных:</strong> Овцы<br />
        <strong>Порода:</strong> Гиссар<br />
        <strong>Адрес и ФИО:</strong> а/о Катта-Талдык,
0555 815555, Кубанычбек уулу Нургазы <br />
      </p>
      </div>
    `,
  },

  {
    latitude:40.316834395173146, 

    longitude: 73.23218566140554  ,
    tooltip: `
      <div>
         <h3 style="margin-top: 0; margin-bottom: 8px; font-size: 16px; color: #333;">ФПФ «Аккула»</h3>
      <p style="margin: 4px 0;">
        <strong>Район:</strong> Кара- Суйский<br />
        <strong>Вид животных:</strong> Овцы<br />
        <strong>Порода:</strong> Гиссар<br />
        <strong>Адрес и ФИО:</strong> а/о Катта-Талдык, 0551 000075, Сатыбалдиев Курсан <br />
      </p>
      </div>
    `,
  },
  
  {
    latitude:40.43852212081834, 

    longitude: 72.84037653137274   ,
    tooltip: `
      <div>
         <h3 style="margin-top: 0; margin-bottom: 8px; font-size: 16px; color: #333;">ФПФ «Кең-Төр»</h3>
      <p style="margin: 4px 0;">
        <strong>Район:</strong> Кара- Суйский<br />
        <strong>Вид животных:</strong> Лошади<br />
        <strong>Порода:</strong> Новокиргизская<br />
        <strong>Адрес и ФИО:</strong> а/о Озгур ,т:07720512814, Осмонов Расулбек <br />
      </p>
      </div>
    `,
  },  
  {
    latitude:40.54150703905022, 

    longitude: 72.94449777822365    ,
    tooltip: `
      <div>
         <h3 style="margin-top: 0; margin-bottom: 8px; font-size: 16px; color: #333;">ФПФ «Токторов»</h3>
      <p style="margin: 4px 0;">
        <strong>Район:</strong> Кара- Суйский<br />
        <strong>Вид животных:</strong> КРС<br />
        <strong>Порода:</strong>Голштино-фризская<br />
        <strong>Адрес и ФИО:</strong> а/о Мады, тел.0559 727 735, Токторов Надырбек <br />
      </p>
      </div>
    `,
  },

  {
    latitude:40.12359584199327, 

    longitude: 72.33143040183874, 
    tooltip: `
      <div>
         <h3 style="margin-top: 0; margin-bottom: 8px; font-size: 16px; color: #333;">ФПФ «Улукман»</h3>
      <p style="margin: 4px 0;">
        <strong>Район:</strong> Кара- Суйский<br />
        <strong>Вид животных:</strong> КРС<br />
        <strong>Порода:</strong>Алатауская<br />
        <strong>Адрес и ФИО:</strong> а/о Кара-Добе, тел.0777436340, 0507436340, Пайзилаев М. <br />
      </p>
      </div>
    `,
  },

  {
    latitude:40.68008231782449, 

    longitude: 73.00747594684249 , 
    tooltip: `
      <div>
         <h3 style="margin-top: 0; margin-bottom: 8px; font-size: 16px; color: #333;">ФПФ «ЖИ Боронбаев»</h3>
      <p style="margin: 4px 0;">
        <strong>Район:</strong> Кара- Суйский<br />
        <strong>Вид животных:</strong> Овцы<br />
        <strong>Порода:</strong>Эдилбай<br />
        <strong>Адрес и ФИО:</strong> Сары-Колотский а/ о, тел.0772 551 414 ,Боронбаев Суюнбек <br />
      </p>
      </div>
    `,
  },

  {
    latitude:40.50665437661101, 

    longitude: 72.6938984215844  , 
    tooltip: `
      <div>
         <h3 style="margin-top: 0; margin-bottom: 8px; font-size: 16px; color: #333;">ФПФ «Маматов»</h3>
      <p style="margin: 4px 0;">
        <strong>Район:</strong> Кара- Суйский<br />
        <strong>Вид животных:</strong> ИИМ<br />
        <strong>Порода:</strong>Алатауская<br />
        <strong>Адрес и ФИО:</strong> а/о Тээке, тел.0555 305 183, Маматов Кутманали <br />
      </p>
      </div>
    `,
  },
  {
    latitude:40.66317985439059, 

    longitude: 73.43019798514035  , 
    tooltip: `
      <div>
         <h3 style="margin-top: 0; margin-bottom: 8px; font-size: 16px; color: #333;">ФПФ "Кадырбаев Эргеш"</h3>
      <p style="margin: 4px 0;">
        <strong>Район:</strong> Кара-Кулжинский<br />
        <strong>Вид животных:</strong> Овцы<br />
        <strong>Порода:</strong>Кыргызская тонкорунная<br />
        <strong>Адрес и ФИО:</strong> Кашка-Жол, а/о, тел.0559004964 ,Эргешов А. <br />
      </p>
      </div>
    `,
  },

  {
    latitude:40.29933637670052,  

    longitude: 74.25113606082354, 
    tooltip: `
      <div>
         <h3 style="margin-top: 0; margin-bottom: 8px; font-size: 16px; color: #333;">ФПФ «Капка-Таш»"</h3>
      <p style="margin: 4px 0;">
        <strong>Район:</strong> Кара-Кулжинский<br />
        <strong>Вид животных:</strong> Овцы<br />
        <strong>Порода:</strong>Кыргызская тонкорунная<br />
        <strong>Адрес и ФИО:</strong> Кызыл жар айыл аймагы,
Карыяев Үмүтбек ,
тел.0755 42 12 12 <br />
      </p>
      </div>
    `,
  },

  {
    latitude:39.566566797210704, 

    longitude: 72.26503614477814  ,
    tooltip: `
      <div>
         <h3 style="margin-top: 0; margin-bottom: 8px; font-size: 16px; color: #333;">ФПФ «Тор-Оток»</h3>
      <p style="margin: 4px 0;">
        <strong>Район:</strong> Чон-Алайскийй<br />
        <strong>Вид животных:</strong>Овцы<br />
        <strong>Порода:</strong>Алай<br />
        <strong>Адрес и ФИО:</strong> а/о Кызыл-Эшме, тел0550 458 488 ,Райымбердиев Жаныбек <br />
      </p>
      </div>
    `,
  },

  {
    latitude:39.550347657848505, 

    longitude: 72.21313454621873  ,
    tooltip: `
      <div>
         <h3 style="margin-top: 0; margin-bottom: 8px; font-size: 16px; color: #333;">ФПФ «Наркул»</h3>
      <p style="margin: 4px 0;">
        <strong>Район:</strong> Чон-Алайскийй<br />
        <strong>Вид животных:</strong>Яки<br />
        <strong>Порода:</strong>Кыргыз<br />
        <strong>Адрес и ФИО:</strong> Дароот-Коргон айыл аймагы,
Патаев Эшмамат ,
т:0777 595018<br />
      </p>
      </div>
    `,
  },

  {
    latitude:40.41393260880443, 

    longitude: 72.20133168204596  ,
    tooltip: `
      <div>
         <h3 style="margin-top: 0; margin-bottom: 8px; font-size: 16px; color: #333;">ФПФ «Кашмир»</h3>
      <p style="margin: 4px 0;">
        <strong>Район:</strong> Араванский<br />
        <strong>Вид животных:</strong>Козы<br />
        <strong>Порода:</strong>Кыргыз тыбыттуу<br />
        <strong>Адрес и ФИО:</strong> а/о Тоо-Моюн Тойгонбаев Сабыр.<br />
      </p>
      </div>
    `,
  },
  {
    latitude:40.78885164267969, 

    longitude: 73.54356132441717   ,
    tooltip: `
      <div>
         <h3 style="margin-top: 0; margin-bottom: 8px; font-size: 16px; color: #333;">ФПФ «Олбосали-Ата»</h3>
      <p style="margin: 4px 0;">
        <strong>Район:</strong> Узгенский<br />
        <strong>Вид животных:</strong>Овцы<br />
        <strong>Порода:</strong>Гиссар<br />
        <strong>Адрес и ФИО:</strong> Семиз-Колский а/о,
Тел.0778 420 910, Алишеров Нурланбек<br />
      </p>
      </div>
    `,
  },

  {
    latitude:40.74236438542541, 

    longitude: 73.39891926466969   ,
    tooltip: `
      <div>
         <h3 style="margin-top: 0; margin-bottom: 8px; font-size: 16px; color: #333;">ФПФ «Асыл»</h3>
      <p style="margin: 4px 0;">
        <strong>Район:</strong> Узгенский<br />
        <strong>Вид животных:</strong>Овцы<br />
        <strong>Порода:</strong>Гиссар<br />
        <strong>Адрес и ФИО:</strong> Торт-Кульский а/о, тел. 0779 871 114, Абдыкадыров Абдылдабек<br />
      </p>
      </div>
    `,
  },
  

  {
    latitude:40.742214147944836, 

    longitude: 73.28611939677559,
    tooltip: `
      <div>
         <h3 style="margin-top: 0; margin-bottom: 8px; font-size: 16px; color: #333;">ФПФ «Таирбек»</h3>
      <p style="margin: 4px 0;">
        <strong>Район:</strong> Узгенский<br />
        <strong>Вид животных:</strong>Овцы<br />
        <strong>Порода:</strong>Гиссар<br />
        <strong>Адрес и ФИО:</strong> Баш-Добенский а/о, тел.0554 114440, Маматов Туратбеков<br />
      </p>
      </div>
    `,
  },

  {
    latitude:42.080992206887025, 

    longitude: 76.82574288076547,
    tooltip: `
      <div>
         <h3 style="margin-top: 0; margin-bottom: 8px; font-size: 16px; color: #333;">ФПФ «Ак-Булун»</h3>
      <p style="margin: 4px 0;">
        <strong>Район:</strong> Тонскиий<br />
        <strong>Вид животных:</strong>Овцы, Яки<br />
        <strong>Порода:</strong>Кыргызская тонкорунная, Кыргыз<br />
        <strong>Адрес и ФИО:</strong> Көк –Сай айыл аймагы,
Акматов Баатырбек Таштанбекович,
т: 0553 622962<br />
      </p>
      </div>
    `,
  },

  {
    latitude:42.37505264624308, 

    longitude: 78.04956568671172 ,
    tooltip: `
      <div>
         <h3 style="margin-top: 0; margin-bottom: 8px; font-size: 16px; color: #333;">ФПФ «Сагындык-Ата»</h3>
      <p style="margin: 4px 0;">
        <strong>Район:</strong> Джети-Огузский<br />
        <strong>Вид животных:</strong>Овцы<br />
        <strong>Порода:</strong>Кыргызская тонкорунная<br />
        <strong>Адрес и ФИО:</strong> Оргочорск.а/о,
Тел.0771698919,
С.Асаналиев<br />
      </p>
      </div>
    `,
  },

  {
    latitude:42.16227061348423, 

    longitude: 77.59515366092492 ,
    tooltip: `
      <div>
         <h3 style="margin-top: 0; margin-bottom: 8px; font-size: 16px; color: #333;">ФПФ «Кыргоо»</h3>
      <p style="margin: 4px 0;">
        <strong>Район:</strong> Джети-Огузский<br />
        <strong>Вид животных:</strong>Яки<br />
        <strong>Порода:</strong>Кыргыз<br />
        <strong>Адрес и ФИО:</strong> Барскоон айыл өкмөтү,
Калчаев Жолдошбек,
т:0557 021187, 0709 499255<br />
      </p>
      </div>
    `,
  },

  {
    latitude:42.37349157998735, 

    longitude: 78.07112804697007  ,
    tooltip: `
      <div>
         <h3 style="margin-top: 0; margin-bottom: 8px; font-size: 16px; color: #333;">ФПФ «Борбу-Ата»</h3>
      <p style="margin: 4px 0;">
        <strong>Район:</strong> Джети-Огузский<br />
        <strong>Вид животных:</strong>Овцы<br />
        <strong>Порода:</strong>Кыргызская тонкорунная<br />
        <strong>Адрес и ФИО:</strong> Жаркынбаев Ж.,
Оргочор а/а,
Тел.0550342146<br />
      </p>
      </div>
    `,
  },{
    latitude:42.149052902928396, 

    longitude: 77.52525852241696  ,
    tooltip: `
      <div>
         <h3 style="margin-top: 0; margin-bottom: 8px; font-size: 16px; color: #333;">ФПФ «Иляс-Ата»</h3>
      <p style="margin: 4px 0;">
        <strong>Район:</strong> Джети-Огузский<br />
        <strong>Вид животных:</strong>Овцы<br />
        <strong>Порода:</strong>Кыргызская тонкорунная<br />
        <strong>Адрес и ФИО:</strong> а/о Тамга ,тел. 0709 516 032 ,Боталиев Талайбек<br />
      </p>
      </div>
    `,
  },{
    latitude:42.19012109607534, 

    longitude: 77.67277058427757  ,
    tooltip: `
      <div>
         <h3 style="margin-top: 0; margin-bottom: 8px; font-size: 16px; color: #333;">ФПФ «Кул-Бай Эл»</h3>
      <p style="margin: 4px 0;">
        <strong>Район:</strong> Джети-Огузский<br />
        <strong>Вид животных:</strong>Овцы<br />
        <strong>Порода:</strong>Кыргызская тонкорунная<br />
        <strong>Адрес и ФИО:</strong> а/о Жаргылчак, тел. 0707 139 937, Бекбоев Данияр<br />
      </p>
      </div>
    `,
  },
  {
    latitude:42.43597016565926, 

    longitude:78.20815701915583  ,
    tooltip: `
      <div>
         <h3 style="margin-top: 0; margin-bottom: 8px; font-size: 16px; color: #333;">ФПФ «Көл-Жылга»</h3>
      <p style="margin: 4px 0;">
        <strong>Район:</strong> Джети-Огузский<br />
        <strong>Вид животных:</strong>Овцы<br />
        <strong>Порода:</strong>Кыргызская тонкорунная<br />
        <strong>Адрес и ФИО:</strong> а/о Жети-Огуз, тел. 0701 489 800, Мендеев Шабдан<br />
      </p>
      </div>
    `,
  },

  {
    latitude:42.44407662346929, 

    longitude:78.18614378990418  ,
    tooltip: `
      <div>
         <h3 style="margin-top: 0; margin-bottom: 8px; font-size: 16px; color: #333;">ФПФ «Сүлүк-Кара»</h3>
      <p style="margin: 4px 0;">
        <strong>Район:</strong> Джети-Огузский<br />
        <strong>Вид животных:</strong>Лошади<br />
        <strong>Порода:</strong>Русская рысистаятуу<br />
        <strong>Адрес и ФИО:</strong> Желе-Добо а/о<br />
      </p>
      </div>
    `,
  },

  {
    latitude:42.4549948666221, 

    longitude:78.107279290861   ,
    tooltip: `
      <div>
         <h3 style="margin-top: 0; margin-bottom: 8px; font-size: 16px; color: #333;">ФПФ «Рысбек-Ата»</h3>
      <p style="margin: 4px 0;">
        <strong>Район:</strong> Джети-Огузский<br />
        <strong>Вид животных:</strong>КРС<br />
        <strong>Порода:</strong>Абердин-ангус<br />
        <strong>Адрес и ФИО:</strong> а/о Ак-Добе, т:0558 565 676, Баялиев Акназар<br />
      </p>
      </div>
    `,
  },
  
  {
    latitude:42.730165670160986, 

    longitude:78.46881027648118   ,
    tooltip: `
      <div>
         <h3 style="margin-top: 0; margin-bottom: 8px; font-size: 16px; color: #333;">ФПФ «Ноорузбай»</h3>
      <p style="margin: 4px 0;">
        <strong>Район:</strong> Тюпский<br />
        <strong>Вид животных:</strong>Овцы<br />
        <strong>Порода:</strong>Кыргызская тонкорунная<br />
        <strong>Адрес и ФИО:</strong> а/о Сары-Добе, тел.0705 492 954 ,Турдумамбетов Рысбек<br />
      </p>
      </div>
    `,
  },

  {
    latitude:42.75729327470791, 

    longitude:78.34258703108958   ,
    tooltip: `
      <div>
         <h3 style="margin-top: 0; margin-bottom: 8px; font-size: 16px; color: #333;">ФПФ «Абакир»</h3>
      <p style="margin: 4px 0;">
        <strong>Район:</strong> Тюпский<br />
        <strong>Вид животных:</strong>Овцы<br />
        <strong>Порода:</strong>Кыргызская тонкорунная<br />
        <strong>Адрес и ФИО:</strong> а/о Сары-Булак, тел.0707 467 858, Курманбаев Замирбек<br />
      </p>
      </div>
    `,
  },

  {
    latitude:42.7789683585305, 

    longitude:78.37623265970458   ,
    tooltip: `
      <div>
         <h3 style="margin-top: 0; margin-bottom: 8px; font-size: 16px; color: #333;">ФПФ «Дуйшон Ата»</h3>
      <p style="margin: 4px 0;">
        <strong>Район:</strong> Тюпский<br />
        <strong>Вид животных:</strong>Овцы<br />
        <strong>Порода:</strong>Кыргызская тонкорунная<br />
        <strong>Адрес и ФИО:</strong> а/о Шаты, тел.0772 200 931, Каптагаев Догдурбай<br />
      </p>
      </div>
    `,
  },

  {
    latitude:42.72348523431146, 

    longitude:78.5323962025763   ,
    tooltip: `
      <div>
         <h3 style="margin-top: 0; margin-bottom: 8px; font-size: 16px; color: #333;">ФПФ «Байтур»</h3>
      <p style="margin: 4px 0;">
        <strong>Район:</strong> Тюпский<br />
        <strong>Вид животных:</strong> Лошади<br />
        <strong>Порода:</strong>Чистокровно верховая<br />
        <strong>Адрес и ФИО:</strong> Арал а/о<br />
      </p>
      </div>
    `,
  },

  {
    latitude:42.78988766970532, 

    longitude:78.45882772180008 ,
    tooltip: `
      <div>
         <h3 style="margin-top: 0; margin-bottom: 8px; font-size: 16px; color: #333;">ФПФ «Сартбай»</h3>
      <p style="margin: 4px 0;">
        <strong>Район:</strong> Тюпский<br />
        <strong>Вид животных:</strong> Овцы<br />
        <strong>Порода:</strong>Кыргызская тонкорунная<br />
        <strong>Адрес и ФИО:</strong> а/о Сары Булак, тел. 0500 100 870, Асанов Нурбек<br />
      </p>
      </div>
    `,
  },
];
const customMarkerIcon = L.icon({
  iconUrl: "/ferm.svg",
  iconSize: [35, 55],
  iconAnchor: [12, 41],
  popupAnchor: [1, -34],
});

export const BreedinFarmMap = (props: IContentPart) => {
  (L as any).drawLocal = getCookie("i18next") === "ky" ? KyLokal : RuLokal;

  const [geoData, setGeoData] = useState<any>(null);
  const [bishkekGeoData, setBishkekGeoData] = useState<any>(null);
  const [batkenGeoData, setBatkenGeoData] = useState<any>(null);
  const [chuiGeoData, setChuiGeoData] = useState<any>(null);
  const [issikulGeoData, setIssikulGeoData] = useState<any>(null);
  const [jalalabadGeoData, setJalalabadGeoData] = useState<any>(null);
  const [narinGeoData, setNarinGeoData] = useState<any>(null);
  const [oshGeoData, setOshGeoData] = useState<any>(null);
  const [oshoblGeoData, setOshoblGeoData] = useState<any>(null);
  const [talasGeoData, setTalasGeoData] = useState<any>(null);
  useEffect(() => {
    const fetchGeoData = async (
      file: string,
      setGeoData: React.Dispatch<React.SetStateAction<any>>,
      label: string
    ) => {
      try {
        const response = await fetch(`/${file}`);
       
        if (!response.ok) {
          throw new Error("Network response was not ok");
        }
        const data = await response.json();
       
        if (data[0] && data[0].geojson) {
          setGeoData(data[0].geojson);
        } else {
          console.warn(
            `Данные geojson отсутствуют или неверный формат в ${label}:`,
            data
          );
        }
      } catch (error) {
      }
    };


    fetchGeoData("polygons/search.json", setGeoData, "polygons/search.json");
    fetchGeoData(
      "polygons/bishkek.json",
      setBishkekGeoData,
      "polygons/bishkek.json"
    );
    fetchGeoData(
      "polygons/batken.json",
      setBatkenGeoData,
      "polygons/batken.json"
    );
    fetchGeoData("polygons/chui.json", setChuiGeoData, "polygons/chui.json");
    fetchGeoData(
      "polygons/issikul.json",
      setIssikulGeoData,
      "polygons/issikul.json"
    );
    fetchGeoData(
      "polygons/jalalabad.json",
      setJalalabadGeoData,
      "polygons/jalalabad.json"
    );
    fetchGeoData("polygons/narin.json", setNarinGeoData, "polygons/narin.json");
    fetchGeoData("polygons/osh.json", setOshGeoData, "polygons/osh.json");
    fetchGeoData(
      "polygons/oshobl.json",
      setOshoblGeoData,
      "polygons/oshobl.json"
    );
    fetchGeoData("polygons/talas.json", setTalasGeoData, "polygons/talas.json");
  }, []);

  const getStyle = (color: string) => ({
    color: color,
    weight: 2,
    opacity: 1,
    fillOpacity: 0.5,
  });

  const onEachFeature = (feature: any, layer: any) => {
    layer.on({
      mouseover: (e: any) => {
        e.target.setStyle({
          weight: 4,
          fillOpacity: 0.7,
        });
      },
      mouseout: (e: any) => {
        e.target.setStyle({
          weight: 2,
          fillOpacity: 0.5,
        });
      },
    });
  };

  return (
    <MapContainer
      className={styles.map}
      center={[41.5089324, 74.724091]}
      zoom={7}
      minZoom={7}
      scrollWheelZoom={true}
      zoomControl={false}
    >
    <TileLayer
        attribution='&copy; <a href="https://www.openstreetmap.org/copyright">OpenStreetMap</a> contributors'
        url="https://{s}.tile.openstreetmap.org/{z}/{x}/{y}.png"
      />
      {/* {geoData && (
        <GeoJSON
          data={geoData}
          style={getStyle("blue")}
          onEachFeature={onEachFeature}
        />
      )} */}

      {markers.map((marker, index) => (
        <Marker
          key={index}
          position={[marker.latitude, marker.longitude]}
          icon={customMarkerIcon}
        >
          <Popup>
            <div dangerouslySetInnerHTML={{ __html: marker.tooltip }} />
          </Popup>
        </Marker>
      ))}
                {/* {geoData && <GeoJSON data={geoData} style={getStyle('grey')} onEachFeature={onEachFeature} />} */}
                {bishkekGeoData && <GeoJSON data={bishkekGeoData} style={getStyle('#AAA9A9')} onEachFeature={onEachFeature} />}
      {batkenGeoData && <GeoJSON data={batkenGeoData} style={getStyle('#AAA9A9')} onEachFeature={onEachFeature} />}
      {chuiGeoData && <GeoJSON data={chuiGeoData} style={getStyle('#AAA9A9')} onEachFeature={onEachFeature} />}
      {issikulGeoData && <GeoJSON data={issikulGeoData} style={getStyle('#AAA9A9')} onEachFeature={onEachFeature} />}
      {jalalabadGeoData && <GeoJSON data={jalalabadGeoData} style={getStyle('#AAA9A9')} onEachFeature={onEachFeature} />}
      {narinGeoData && <GeoJSON data={narinGeoData} style={getStyle('#AAA9A9')} onEachFeature={onEachFeature} />}
      {/* {oshGeoData && <GeoJSON data={oshGeoData} style={getStyle('#AAA9A9')} onEachFeature={onEachFeature} />} */}
      {oshoblGeoData && <GeoJSON data={oshoblGeoData} style={getStyle('#AAA9A9')} onEachFeature={onEachFeature} />}
      {talasGeoData && <GeoJSON data={talasGeoData} style={getStyle('#AAA9A9')} onEachFeature={onEachFeature} />}
    </MapContainer>
  );
};
